import { ensureArray } from "../../utils/JSUtils";

// adds propUpdates to an array and feeds each one to the updater callback
export const batchPropChanges = (propUpdates, updaterCallback) => {
  const updates = ensureArray(propUpdates);
  updates.forEach(updaterCallback);
};

// formats the name property on each prop update using the provided formatter
export const formatPropNames = (propUpdates, formatter) => {
  const updates = ensureArray(propUpdates);
  return updates.map(({ name: unformattedName, ...rest }) => ({
    name: formatter(unformattedName),
    ...rest,
  }));
};

